import type { AlertRuleType, AlertScopeKind, AlertSeverity, AlertStatus } from '@chukua/common';

export const ALERT_TYPE_LABELS: Record<AlertRuleType, string> = {
  tracker_silent: 'Tracker silent',
  geofence: 'Geofence',
  speeding: 'Speeding',
  speeding_sustained: 'Sustained speeding',
  stopped: 'Stopped too long',
  idling: 'Idling',
  off_route: 'Off route',
  unsafe_stop: 'Unsafe stop',
  fuel_drop: 'Fuel drop',
  tracker_tamper: 'Tracker tamper',
};
export const ALERT_SEVERITY_LABELS: Record<AlertSeverity, string> = { info: 'Info', warning: 'Warning', critical: 'Critical' };
export const ALERT_STATUS_LABELS: Record<AlertStatus, string> = { open: 'Open', acknowledged: 'Acknowledged', resolved: 'Resolved' };

export const ALERT_SCOPE_LABELS: Record<AlertScopeKind, string> = {
  company: 'Whole company',
  truck_class: 'Truck classes',
  unit: 'Specific units',
};

export const SEVERITY_TAG_COLOURS: Record<AlertSeverity, string> = { info: 'default', warning: 'warning', critical: 'error' };
export const STATUS_TAG_COLOURS: Record<AlertStatus, string> = { open: 'error', acknowledged: 'processing', resolved: 'success' };

export const toOptions = <K extends string>(labels: Record<K, string>) => (Object.keys(labels) as K[]).map((key) => ({ value: key, label: labels[key] }));
export const toColumnFilters = <K extends string>(labels: Record<K, string>) => (Object.keys(labels) as K[]).map((key) => ({ value: key, text: labels[key] }));
